import React, { Component } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import SeatingDashboardLeft from "./MainAllPagesLink";
import { SeatingDashboardRight } from "../../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/SeatingDashboardRight";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import SeatingScreen from "./inside/SeatingScreen";
import PendingScreen from "./inside/PendingScreen";
import ReservationScreen from "./inside/ReservationScreen";
import HistoryScreen from "./inside/HistoryScreen";

import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
  get_all_vendor_reservation_information,
  get_all_vendor_history_information,
} from "../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import isEmpty from "../../../../../store/validation/is-Empty";

export class MainSeatingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendorData: {},
      seatingTab: 1,
    };
  }

  onClickTabChange = (type) => (e) => {
    this.setState({
      seatingTab: type,
    });
  };

  componentDidMount() {
    if (
      this.props.location.state !== null &&
      this.props.location.state !== undefined
    ) {
      this.setState({
        vendorData: this.props.location.state.data,
      });
    }
  }

  render() {
    const { vendorData } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Users" />
              <div className="super_admin_seating_box_content">
                <div className="row super_admin_seating_header">
                  <div className="col-1">
                    <img
                      src={vendorData.logo_url}
                      alt="Business Logo"
                      title="Business Logo"
                      className="img-fluid business_logo"
                    />
                  </div>
                  <div className="col-4">
                    <h5 className="business_name mb-2">
                      {vendorData.restaurant_name}
                    </h5>
                    <p className="font_20_r">{vendorData.restaurant_address}</p>
                  </div>
                </div>
                <div className="w-100">
                  <hr />
                </div>
                <div className="container-fluid seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h4>
                        {this.state.seatingTab === 1
                          ? "Seating Dashboard"
                          : null || this.state.seatingTab === 2
                          ? "Pending Dashboard"
                          : null || this.state.seatingTab === 3
                          ? "Reservation Dashboard"
                          : null || this.state.seatingTab === 4
                          ? "History Dashboard"
                          : null}
                      </h4>
                    </div>
                    <div className="col-6 text-right">
                      {/* <button className="btn add_button_custom_1">
                        + Add Diner
                      </button> */}
                      <button
                        onClick={() =>
                          this.props.history.push({
                            pathname: "/superadmindashboard/adminadddiner",
                            state: { data: vendorData },
                          })
                        }
                        to="/superadmindashboard/adminadddiner"
                        className="btn btn-danger btn-lg"
                      >
                        + Add Diner
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-12 row">
                  <SeatingDashboardLeft
                    selectedPage={this.state.seatingTab}
                  />
                  {this.state.seatingTab === 3 ? (
                    <ReservationScreen data={vendorData} />
                  ) : (
                    <SeatingDashboardRight
                      totalCount={this.props.allDinnerDetails.length}
                      pendingCount={this.props.allPendingDiners.length}
                      walkinCount={this.props.allDinnerDetails.length}
                      reservationCount={this.props.allReservationDiners.length}
                    />
                  )}
                  {this.state.seatingTab === 1 ? (
                    <SeatingScreen data={vendorData} />
                  ) : null || this.state.seatingTab === 2 ? (
                    <PendingScreen data={vendorData} />
                  ) : null || this.state.seatingTab === 4 ? (
                    <HistoryScreen data={vendorData} />
                  ) : null}
                </div>
                <div className="super-admin-inside-right-side-panel">
                  {/* <BasicPagination
                totalRecords={props.allUserList.length}
                limit={10}
                batch={page}
                onBatchChange={(e) => handleBatchChange(e)}
              /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MainSeatingComponent.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allDinnerDetails: state.adminAllVendorsInfo.superAdminGetSeatingVendorDiner,
  allPendingDiners: state.adminAllVendorsInfo.superAdminGetPendingVendorDiner,
  allReservationDiners:
    state.adminAllVendorsInfo.superAdminGetReservationVendorDiner,
  allHistoryDiners: state.adminAllVendorsInfo.superAdminGetHistoryVendorDiner,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
  get_all_vendor_reservation_information,
  get_all_vendor_history_information,
})(withRouter(MainSeatingComponent));
